<template>
  <div>
        
    <div v-if="!item_category_id" :style="{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'space-between',
          flexWrap: 'wrap',
          textAlign: 'left'
        }">
        <div :style="{display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          textAlign: 'left', width: '80%'}">

        <div style="margin-top: 10px;">
            <span type="label">Old Weight</span>
            <br>
            <el-input @focus="$event.target.select()"
                size="small"
                v-model="$store.state.customerMaster.props.old_weight"
                style="width: 250px;">
                <template slot="append">Kg/Pounds</template>
            </el-input>
        </div>
        <div style="margin-top: 10px;margin-left: 10px;">
            <span type="label">New Weight</span>
            <br>
            <el-input @focus="$event.target.select()"
                size="small"
                v-model="$store.state.customerMaster.props.new_weight"
                style="width: 250px;">
                <template slot="append">Kg/Pounds</template>
            </el-input>
        </div>
        <div style="margin-top: 10px;margin-left: 10px;">
            <span type="label">Height</span>
            <br>
            <el-input @focus="$event.target.select()"
                size="small"
                type="number"
                v-model="$store.state.customerMaster.props.height"
                style="width: 250px;">
                <template slot="append">Feets</template>
            </el-input>
        </div>
        </div>
        <div style="width: 20%; text-align: right; margin-top: 20px;">
            <el-button 
                v-if="$store.state.customerMaster.props.id>0"
                size="small" 
                type="primary" 
                @click="loadAllMsmtHistory" 
                :loading="$store.getters.getLoadingState">
                Load All History
            </el-button>
            <span v-else v-html="'&nbsp;'">

            </span>
        </div>
        
    </div>
    <el-tabs v-if="!item_category_id" :tab-position="'left'" type="border-card" style="margin-top: 20px;">
        <el-tab-pane 
            v-for="(data, index) in getMeasurementTemplateList"
            :key="index"
            :label="data.category_name">
                <ProfileList 
                    :item_category_id="data.category_id"
                    :item_category_name="data.category_name"
                    :master_measurement_list="data.measurement_list"/>
        </el-tab-pane>                   
    </el-tabs>
    <div v-else>
        <ProfileList 
            :msmt_form="msmt_form"
            :item_category_id="item_category_id"
            :inline="true"
            :customer_measurement_profile="customer_measurement_profile"/>
    </div>
    
    <div v-if="!item_category_id" style="height: 0px;">
        {{getTempMeasurementProfile}}
    </div>
    
  </div>
</template>

<script>
import ProfileList from './ProfileList.vue'
import MasterMeasurementSheet from '../MasterMeasurementSheet.vue'

export default {
    props: ['item_category_id', 'customer_measurement_profile', 'msmt_form'],
    components: {MasterMeasurementSheet, ProfileList},
    methods: {
        loadAllMsmtHistory() {
            this.$store.state.customerMaster.props.load_all_msmt_history = true
            this.$store.dispatch('fetchCustomerMasterMeasurementData', 
                { id: this.$store.state.customerMaster.props.id, copy: false, navigate: false, load_all_msmt_history: true })
        }
    },
    computed: {
        getMeasurementTemplateList() {
            if(this.item_category_id) {
                return this.$store.getters.getMeasurementTemplateList.filter((element) => element.category_id === this.item_category_id)
            } else {
                return this.$store.getters.getMeasurementTemplateList
            }
        },
        getCustomerMeasurementProfileList() {
            return this.$store.getters.getCustomerMasterDataProps.measurement_profile_list
        },
        getTempMeasurementProfile() {
            
            this.getMeasurementTemplateList.forEach(element => {
                let existingCustomerProfile = this.getCustomerMeasurementProfileList.filter((element1) => {
                    return element1.tailoring_category_id === element.category_id
                })
                
                if(existingCustomerProfile.length > 0) {
                    existingCustomerProfile.forEach(element1 => {

                        let profile_list = element1.profile_list
                        this.$store.state.customerMaster.props.temp_measurement_profile_list.push({
                            tailoring_category_id: element1.tailoring_category_id,
                            profile_list
                        })
                    })
                    
                } else {
                    this.$store.state.customerMaster.props.temp_measurement_profile_list.push({
                        tailoring_category_id: element.category_id,
                        profile_list: []
                    })
                }
                
            })

            return this.$store.state.customerMaster.props.temp_measurement_profile_list
            
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/CustomerMaster/Form/MeasurementProfile/Index.vue